/**
 * Notification Utilities
 * Toast notification helpers
 *
 * @module NotificationUtils
 * Sprint 32: OOA/OOD Refactoring
 */

export type NotificationType = 'info' | 'success' | 'warning' | 'error';

/**
 * Show a toast notification
 */
export function showNotification(message: string, type: NotificationType = 'info'): void {
    if (typeof window !== 'undefined' && (window as any).showToastNotification) {
        (window as any).showToastNotification(message, type);
    } else {
        // Fallback to console
        const logMethod = type === 'error' ? console.error :
                         type === 'warning' ? console.warn :
                         console.log;
        logMethod(`[${type.toUpperCase()}] ${message}`);
    }
}

/**
 * Show info notification
 */
export function showInfo(message: string): void {
    showNotification(message, 'info');
}

/**
 * Show success notification
 */
export function showSuccess(message: string): void {
    showNotification(message, 'success');
}

/**
 * Show warning notification
 */
export function showWarning(message: string): void {
    showNotification(message, 'warning');
}

/**
 * Show error notification
 */
export function showError(message: string): void {
    showNotification(message, 'error');
}
